import React from 'react'
import { CadastrarCaixa } from '@newspacebpo/mf_protocolo_bfveic'
const CadastrarCaixaPage = (props) => {
    return (
            <CadastrarCaixa {...props}/>
    );
};

export { CadastrarCaixaPage };